import axios from 'axios';

export default {
  getAllPictures(page) {
    return axios.get('api/pictures', { params: { page: page, }, })
      .then(response => {
        return response.data;
      }).catch(error => {
        return Promise.reject(error.response.data);
      });
  },
};
